import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AddPatientComponent } from './add-patient.component';

const requestAppointmentRoutes: Routes = [
  { path: '', component: AddPatientComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(requestAppointmentRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})

export class AddPatientRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/add-patient/add-patient.routing.ts